import React, { useState } from 'react';
import {
  Button,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import useSnackbar from '../../../hooks/useSnackbar'; // Custom hook for Snackbar
import { ErrorCodeCategory } from '../../../utils/entities/type';

export interface ErrorcodeFilterData {
  category: ErrorCodeCategory | '';
}

const ErrorcodeFilter = ({
  category,
  onFiltered,
  onResetFilter,
  handleDrawerClose,
}: any) => {
  const { showSnackbar, SnackbarComponent } = useSnackbar(); // Using custom hook for Snackbar
  const [filterData, setFilterData] = useState<ErrorcodeFilterData>({
    category: category ? category : '', // Default to an empty string for initial state
  });

  // Handle dropdown change
  const handleChange = (e: any) => {
    setFilterData({
      category: e.target.value as ErrorCodeCategory | '',
    });
  };

  // Handle form submit
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!filterData.category) {
      showSnackbar('Please select a category to filter', 'warning');
      return;
    }
    onFiltered(filterData);
    handleDrawerClose();
  };

  // Handle form reset
  const handleReset = () => {
    setFilterData({
      category: '',
    });
    onResetFilter();
  };

  return (
    <Box sx={{ flex: 1 }}>
      {SnackbarComponent}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Category Dropdown */}
        <FormControl fullWidth>
          <InputLabel id="category-label">Category</InputLabel>
          <Select
            labelId="category-label"
            value={filterData.category}
            onChange={handleChange}
            label="Category"
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="INVERTOR">Invertor</MenuItem>
            <MenuItem value="NON_INVERTOR">Non-Invertor</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button type="button" variant="outlined" onClick={handleReset}>
            Reset
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Apply Filter
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorcodeFilter;
